export function sanitizeMoneyInput(value) {
  if (value === "") return "";

  let filtered = value.replace(/,/g, ".").replace(/[^\d.]/g, "");

  const firstDot = filtered.indexOf(".");
  if (firstDot !== -1) {
    filtered =
      filtered.slice(0, firstDot + 1) +
      filtered.slice(firstDot + 1).replace(/\./g, "");
  }

  if (filtered.startsWith(".")) {
    filtered = "0" + filtered;
  }

  const dotIndex = filtered.indexOf(".");
  let intPart = dotIndex === -1 ? filtered : filtered.slice(0, dotIndex);
  let decPart = dotIndex === -1 ? "" : filtered.slice(dotIndex + 1);

  decPart = decPart.slice(0, 2);

  if (intPart.length > 1) {
    intPart = /^0+$/.test(intPart) ? "0" : intPart.replace(/^0+/, "");
  }

  if (dotIndex !== -1) {
    const normalizedInt = intPart || "0";
    if (decPart !== "" || filtered.endsWith(".")) {
      return `${normalizedInt}.${decPart}`;
    }
    return `${normalizedInt}.`;
  }

  return intPart;
}

export function parseMoneyAmount(value) {
  return Number(String(value).replace(",", ".")) || 0;
}

export function formatMoneyValue(num) {
  const n = Number(num);
  if (isNaN(n) || n === 0) return "0,00";
  return n.toFixed(2).replace(".", ",");
}

export function formatMoneyOnBlur(value) {
  if (value === "" || value === "." || value == null) return "0,00";

  let filtered = sanitizeMoneyInput(String(value));
  if (filtered === "" || filtered === ".") return "0,00";

  if (filtered.endsWith(".")) {
    filtered = filtered.slice(0, -1);
  }
  if (filtered === "") return "0,00";

  const num = parseFloat(filtered);
  if (isNaN(num)) return "0,00";

  return formatMoneyValue(num);
}

export function formatMoneyDisplay(value) {
  const num = Number(value);
  if (isNaN(num)) return "0,00 руб";
  return `${num.toFixed(2).replace(".", ",")} руб`;
}

export function handleMoneyInputKeyDown(e) {
  if (e.ctrlKey || e.metaKey || e.altKey) return;

  const allowedControlKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Tab",
    "Enter",
  ];

  if (allowedControlKeys.includes(e.key)) return;
  if (/^\d$/.test(e.key)) return;

  if (e.key === "." || e.key === ",") {
    const input = e.currentTarget;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;
    const value = input.value;
    const separatorIndex = Math.max(value.indexOf(","), value.indexOf("."));
    const selectionIncludesSeparator =
      separatorIndex >= selectionStart && separatorIndex < selectionEnd;

    if (separatorIndex === -1 || selectionIncludesSeparator) return;
  }

  e.preventDefault();
}

export function handleMoneyInputBeforeInput(e) {
  const inputText = e.data;
  if (inputText == null) return;

  const input = e.currentTarget;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;
  const value = input.value;

  if (/^\d+$/.test(inputText)) return;

  if (inputText === "." || inputText === ",") {
    const separatorIndex = Math.max(value.indexOf(","), value.indexOf("."));
    const selectionIncludesSeparator =
      separatorIndex >= selectionStart && separatorIndex < selectionEnd;

    if (separatorIndex === -1 || selectionIncludesSeparator) return;
  }

  e.preventDefault();
}

export function focusMoneyInputSelection(inputEl) {
  if (inputEl) {
    inputEl.dataset.moneyLastValue = inputEl.value;
  }

  if (inputEl?.value === "0,00") {
    inputEl.setSelectionRange(0, 1);
  }
}

export function applyMoneyInputValue(inputEl) {
  if (!inputEl) return null;

  const selectionStart = inputEl.selectionStart ?? 0;
  const selectionEnd = inputEl.selectionEnd ?? 0;
  const rawValue = inputEl.value;

  const filteredValue = sanitizeMoneyInput(rawValue);
  if (filteredValue === "" && rawValue !== "") {
    inputEl.value = inputEl.dataset.moneyLastValue ?? "";
    const pos = Math.min(selectionStart, inputEl.value.length);
    inputEl.setSelectionRange(pos, pos);
    return null;
  }

  const newValue = filteredValue.replace(".", ",");
  const normalizedRawValue = rawValue.replace(".", ",");
  inputEl.value = newValue;
  inputEl.dataset.moneyLastValue = newValue;

  if (newValue === normalizedRawValue) {
    inputEl.setSelectionRange(selectionStart, selectionEnd);
  } else {
    const cursorOffset = newValue.length - normalizedRawValue.length;
    const cursorPosition = Math.max(
      0,
      Math.min(selectionStart + cursorOffset, newValue.length),
    );
    inputEl.setSelectionRange(cursorPosition, cursorPosition);
  }

  return filteredValue;
}
